import {
  Box,
  Button,
  Image,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { Img } from "../../../../content/Content";
import'./member.component.css'
const Member = () => {
  return (
    <VStack bg={"rgba(245, 245, 255, 1)"} py={"50px"}>
      {/* desktop version */}
      <Box w={"80%"} m="auto" className="desktop-member">
        <Stack w={"100%"} flexDirection={"row"}>
          <Stack w="50%">
            <Box position={"relative"} mx={'10px'}>
              <Image
                src={Img.member1}
                alt="photo"
                w={"100%"}
                h={"auto"}
                borderRadius={"35px"}
              />
              <Box
                pe="25px"
                position={"absolute"}
                display="flex"
                justifyContent={"center"}
                flexDir={"column"}
                alignItems={"center"}
                height={"100%"}
                w={"100%"}
                left={"0"}
                right={"0"}
                top={"0"}
                bottom={"0"}
              >
                <Text
                  lineHeight={"0.5"}
                  my="10px"
                  p="0"
                  color="#fff"
                  fontSize={"40px"}
                  fontWeight={"700"}
                  fontFamily={"'Poppins', sans-serif;"}
                >
                  Are you new Member
                </Text>
                <Text color="#fff" fontSize={"23px"} fontWeight={"400"} fontFamily={"'Poppins', sans-serif;"} my={"10px"}>
                  Spend first 2 week our basic package
                </Text>
                <Button
                  borderRadius={"25px"}
                  type="button"
                  fontSize={"23px"}
                  fontWeight={"500"}
                  cursor={"pointer"}
                  border={"none"}
                  p="10px 25px"
                  color="rgba(0, 0, 0, 1)"
                  bg="#fff"
                  fontFamily={"'Poppins', sans-serif;"}
                >
                  Click here
                </Button>
              </Box>
            </Box>
          </Stack>

          <Stack w="50%">
            <Box position={"relative"} mx={'10px'}>
              <Image
                src={Img.member2}
                alt="photo"
                w={"100%"}
                h={"auto"}
                borderRadius={"35px"}
              />
              <Box
                pe="25px"
                position={"absolute"}
                display="flex"
                justifyContent={"center"}
                flexDir={"column"}
                alignItems={"center"}
                height={"100%"}
                w={"100%"}
                left={"0"}
                right={"0"}
                top={"0"}
                bottom={"0"}
              >
                <Image
                  src={Img.chanelLogo6}
                  alt="photo"
                  h={"auto"}
                  maxW={"100%"}
                />
                <Text
                  lineHeight={"0.5"}
                  my="20px"
                  p="0"
                  color="#fff"
                  fontSize={"40px"}
                  fontWeight={"700"}
                  fontFamily={"'Poppins', sans-serif;"}
                >
                  Stock and Features
                </Text>
                <Button
                  borderRadius={"25px"}
                  type="button"
                  fontSize={"23px"}
                  fontWeight={"500"}
                  cursor={"pointer"}
                  border={"none"}
                  p="10px 25px"
                  color="rgba(0, 0, 0, 1)"
                  fontFamily={"'Poppins', sans-serif;"}
                  bg={"#fff"}
                >
                  Click here
                </Button>
              </Box>
            </Box>
          </Stack>
        </Stack>
      </Box>
      {/* mobile version */}
      <Box w={"80%"} m="auto" className="mobile-member">
        <Stack w={"100%"} >
          <Stack w="100%">
            <Box position={"relative"}  w="100%">
              <Image
                src={Img.member1}
                alt="photo"
                w={"100%"}
                h={"auto"}
                borderRadius={"35px"}
              />
              <Box
                position={"absolute"}
                display="flex"
                justifyContent={"center"}
                flexDir={"column"}
                alignItems={"center"}
                height={"100%"}
                w={"100%"}
                left={"0"}
                right={"0"}
                top={"0"}
                bottom={"0"}
              >
                <Text
                  lineHeight={"0.5"}
                  my="10px"
                  p="0"
                  color="#fff"
                  fontSize={"24px"}
                  fontWeight={"700"}
                  fontFamily={"'Poppins', sans-serif;"}
                >
                  Are you new Member
                </Text>
                <Text px="20px" textAlign="center" color="#fff" fontSize={"16px"} fontWeight={"400"} fontFamily={"'Poppins', sans-serif;"} my={"10px"}>
                  Spend first 2 week our basic package
                </Text>
                <Button
                  borderRadius={"25px"}
                  type="button"
                  fontSize={"16px"}
                  fontWeight={"500"}
                  cursor={"pointer"}
                  border={"none"}
                  p="10px 25px"
                  color="rgba(0, 0, 0, 1)"
                  bg="#fff"
                  fontFamily={"'Poppins', sans-serif;"}
                >
                  Click here
                </Button>
              </Box>
            </Box>
          </Stack>
          <Stack w="100%" py="20px">
            <Box position={"relative"}  w="100%">
              <Image
                src={Img.member2}
                alt="photo"
                w={"100%"}
                h={"auto"}
                borderRadius={"35px"}
              />
              <Box
                position={"absolute"}
                display="flex"
                justifyContent={"center"}
                flexDir={"column"}
                alignItems={"center"}
                height={"100%"}
                w={"100%"}
                left={"0"}
                right={"0"}
                top={"0"}
                bottom={"0"}
              >
                <Image
                  src={Img.chanelLogo6}
                  alt="photo"
                  h={"77px"}
                  maxW={"100%"}
                />
                <Text
                  lineHeight={"0.5"}
                  my="20px"
                  p="0"
                  color="#fff"
                  fontSize={"24px"}
                  fontWeight={"700"}
                  fontFamily={"'Poppins', sans-serif;"}
                >
                  Stock and Features
                </Text>
                <Button
                  borderRadius={"25px"}
                  type="button"
                  fontSize={"16px"}
                  fontWeight={"500"}
                  cursor={"pointer"}
                  border={"none"}
                  p="10px 25px"
                  color="rgba(0, 0, 0, 1)"
                  fontFamily={"'Poppins', sans-serif;"}
                  bg={"#fff"}
                >
                  Click here
                </Button>
              </Box>
            </Box>
          </Stack>
        </Stack>
      </Box>
    </VStack>
  );
};

export default Member;
